<template>
    <b-modal ref="modal" :centered="data.centered || false" :hide-footer="false" :hide-header-close="data.hideHeaderClose || false" :no-close-on-backdrop="data.noCloseOnBackdrop || true" :no-close-on-esc="data.noCloseOnEsc || false" :ok-only="true" :ok-title="_trans('Ok')" :scrollable="data.scrollable || false" :size="data.size || 'md'" @hidden="onClose" @hide="hide" @ok="close(1)" @shown="onShow">
        <template v-slot:modal-title>
            <h5 class="modal-title" v-text="_trans('Project name')"></h5>
        </template>
        <div>
            <input ref="setPrjname" v-model="prj.des" :placeholder="_trans('project name')" class="form-control mt-3" type="text" @keyup.enter="updateAndConfirm()" />
        </div>
        <template v-slot:modal-footer>
            <button :disabled="!canSubmit" class="btn btn-primary" type="button" @click="updateAndConfirm()" v-text="_trans('Update and continue')"></button>
        </template>
    </b-modal>
</template>
<script>
    import modal from "@dialogs/modal.vue";

    export default {
        mixins: [modal],
        data() {
            return {};
        },
        computed: {
            prj() {
                return this.$store.state.project;
            },
            canSubmit() {
                return this.prj.des !== "";
            }
        },
        methods: {
            onShow() {
                this.$refs.setPrjname.focus();
            },
            updateAndConfirm() {
                if (this.prj.des !== "") {
                    this.close(1);
                }
            }
        }
    };
</script>
<style></style>



// WEBPACK FOOTER //
// src/custom/mbstalas/dialogs/modalSetProjectName.vue